export default {"src":"/_next/static/media/telegram.a3c75624.svg","height":136,"width":136,"blurWidth":0,"blurHeight":0};